import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output } from '@angular/core';
import { GeometryResponse, GeometrySteps } from 'src/app/data/model/gps-address-data';
import * as L from 'leaflet';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { mapURL } from 'src/environments/environment.api';
import { NoGpsPointsDialogComponent } from 'src/app/features/map/components/no-gps-points.component';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Steps } from 'src/app/data/model/steps';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TaggableResourcePickupRoute } from 'src/app/data/model/taggable-resource-pickup-route';
import { TaggableResourceRouteListService } from '../../services/taggable-resource-route-list.service';

@Component({
  standalone: false,
  selector: 'app-taggable-resource-route-map',
  templateUrl: './taggable-resource-route-map.component.html',
  styleUrls: ['./taggable-resource-route-map.component.scss']
})
export class TaggableResourceRouteMapComponent  {

  constructor(
    @Inject(MAT_DIALOG_DATA) public route: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<TaggableResourceRouteMapComponent>,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private service: TaggableResourceRouteListService
  ) { }

  @Output() map$: EventEmitter<L.Map>= new EventEmitter;
  @Output() zoom$: EventEmitter<number>=new EventEmitter;
  zoom!:number;
  opened=false;
  loading:boolean=false;
  saveBtn:boolean=false;
  data!:GeometryResponse;
  public map!: L.Map;


  stopScroll(event: WheelEvent): void {
    event.stopPropagation();
  }

  onDragStart(): void {
    if (this.map) {
      this.map.dragging.disable();
      this.map.scrollWheelZoom.disable();
    }
  }
  
  onDragEnd(): void {
    if (this.map) {
      this.map.dragging.enable();
      this.map.scrollWheelZoom.enable();
    }
  }


  mapUrl = mapURL.mapUrl !== '${mapURL}' ? mapURL.mapUrl : mapURL.defaultMapUrl;
  @Input() options: L.MapOptions= {
    layers:[L.tileLayer(`${this.mapUrl}/styles/m2openmaptiles/{z}/{x}/{y}.png`, {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  })],
  zoom:7,
  center:L.latLng(43.300084381319905, 12.34134765625),
};



  setIcon(type:String){
    if (type === 'start') {
      return L.Icon.extend({
        options:
          {
            iconSize: [21, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/start.png'
          }
        })
    } else if (type === 'stop') {
      return L.Icon.extend({
        options:
          {
            iconSize: [21, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/finish.png'
          }
        })
    } else {
      return L.Icon.extend({
        options:
        {
          iconSize: [21, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/marker-icon.png',
          shadowUrl: '../../../../assets/images/markshadow.png'
        }
        })
    }
  }


  private decode(str: string, precision:number): L.LatLngExpression[]{
    var index = 0,
        lat = 0,
        lng = 0,
        coordinates:L.LatLng[] = [],
        shift = 0,
        result = 0,
        byte = null,
        latitude_change,
        longitude_change,
        factor = Math.pow(10, precision || 6);

    while (index < str.length) {

        // Reset shift, result, and byte
        byte = null;
        shift = 0;
        result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

        shift = result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));

        lat += latitude_change;
        lng += longitude_change;
        const latitude=lat / factor
        const longitude=lng / factor
        coordinates.push(L.latLng(latitude, longitude));
    }

    return coordinates;
 }

  toggleDisplayDiv() {  
    this.opened = !this.opened;  
  }  

  reorder(event: GeometrySteps[]) {
    this.data.steps=event;
    this.saveBtn=true;
    
  }

  saveRoute(){
    this.route["reorder"]="1"
    this.route.generated_route=this.data
    this.loading=true
    this.service.changeState(this.route).subscribe({
    next: (res) => {
      this.loading = false;
      this.dialogRef.close(true);  
    },
    error: (err) => {
      this.loading = false;
      this.snackBar.open(`Errore nel percorso ${err}, verificare che tutti i punti segnalati siano su strada`, 'Chiudi', { duration: 3000 });
    }
  });
  }

  setWayPoints(markers: L.FeatureGroup, route:TaggableResourcePickupRoute){
    //markers.cl
    const markerClusterGroup = L.markerClusterGroup();
    this.data=route.generated_route
    this.data.steps.forEach(step => {
      const [lat, lng] = step.street_coords;
      if (step.type === 1){
        const start_icon=this.setIcon('start');
        const marker = L.marker([lat, lng], {icon: new start_icon, draggable: true}).addTo(markers);//markerClusterGroup);
        marker.bindPopup(`<b>Address:</b> ${step.address} <b>order:</b> ${step.order}`);
        marker.on('dragend', (e) => {
          const newLatLng = marker.getLatLng();
          step.street_coords = [newLatLng.lat, newLatLng.lng];
          marker.on('dragend', (e) => {
            const newLatLng = marker.getLatLng();
            step.street_coords = [newLatLng.lat, newLatLng.lng];
            this.service.checkIfOnRoad(newLatLng.lat, newLatLng.lng).subscribe(res => {
              if (res){
                step.street_coords = [newLatLng.lat, newLatLng.lng];
                this.showSuccessMessage(step.order);
                this.saveBtn=true
              } else {
                this.showErrorMessage(step.order);
              }
            })
          });
        });
      } else if (step.type === 2){
        const finish_icon=this.setIcon('stop');
        const marker = L.marker([lat, lng], {icon: new finish_icon, draggable: true}).addTo(markers);//markerClusterGroup);
        marker.bindPopup(`<b>Address:</b> ${step.address} <b>order:</b> ${step.order}`);
        marker.on('dragend', (e) => {
          const newLatLng = marker.getLatLng();
          step.street_coords = [newLatLng.lat, newLatLng.lng]; 
          marker.on('dragend', (e) => {
            const newLatLng = marker.getLatLng();
            step.street_coords = [newLatLng.lat, newLatLng.lng];
            this.service.checkIfOnRoad(newLatLng.lat, newLatLng.lng).subscribe(res => {
              if (res){
                step.street_coords = [newLatLng.lat, newLatLng.lng];
                this.showSuccessMessage(step.order);
                this.saveBtn=true
              } else {
                this.showErrorMessage(step.order);
              }
            })
          });
        });
      }else {
        const icon=this.setIcon('standard');
        const marker = L.marker([lat, lng], {icon: new icon, draggable: true}).addTo(markerClusterGroup);
        marker.bindPopup(`<b>Address:</b> ${step.address} <b>order:</b> ${step.order}`);
        marker.on('dragend', (e) => {
          const newLatLng = marker.getLatLng();
          step.street_coords = [newLatLng.lat, newLatLng.lng];
          this.service.checkIfOnRoad(newLatLng.lat, newLatLng.lng).subscribe(res => {
            if (res){
              step.street_coords = [newLatLng.lat, newLatLng.lng];
              this.showSuccessMessage(step.order);
              this.saveBtn=true
            } else {
              this.showErrorMessage(step.order);
            }
          })
        });
      }
    });
    markerClusterGroup.addTo(markers)
    L.polyline(this.decode(this.data.geometry, 5), { color: 'blue' }).addTo(markers);
  }

  showErrorMessage(step:number) {
    this.snackBar.open(`Coordinate non aggiornate per punto ${step} siccome non su strada`, 'Chiudi', {
      duration: 10000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      direction:'ltr',
      panelClass: ["snackBar-fail"]
    });
  }

  showSuccessMessage(step:number) {
    this.snackBar.open(`Coordinate aggiornate per punto ${step}`, 'Chiudi', {
      duration: 10000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      direction:'ltr',
      panelClass: ["snackBar-success"]
    });
  }

  onMapReady(map: L.Map) {
    this.map = map;
    this.map$.emit(map);
    this.zoom = map.getZoom();
    this.zoom$.emit(this.zoom);
    var markers= new L.FeatureGroup();
    this.setWayPoints(markers, this.route);
    markers.addTo(map);

  }

  onMapZoomEnd(e: L.LeafletEvent) {
    this.zoom = e.target.getZoom();
    this.zoom$.emit(this.zoom);
  }

  flyToPoint(event:Steps){
    if (event.street_coords != null){
      this.map.flyTo(event.street_coords, 18)
    } else {
      this.openNoGpsPointsDialog();
    }
  }

  private openNoGpsPointsDialog(): void {
    this.dialog.open(NoGpsPointsDialogComponent, {
      width: '300px',
      data: { message: 'Punto Gps non trovato.' }//il mezzo selezionato non riporta nessun punto GPS
    });
  }

}
